import styled from 'styled-components';

import {
  Close as MuiClose,
  ArrowBack,
  Schedule,
  CalendarTodayOutlined,
  WarningAmber,
} from '@mui/icons-material';
import { Avatar, Typography, Checkbox as MuiCheckbox } from '@mui/material';
import { wellzTheme as wellzThemeMui } from '@wellz-theme/mui';
import { wellzTheme } from 'theme';

export const Header = styled.div`
  display: flex;
  padding: ${wellzThemeMui.spacing(2)};
  padding-left: ${wellzThemeMui.spacing(7)};
  align-items: center;

  ${wellzThemeMui.breakpoints.down('md')} {
    width: 100%;
    margin: 0px;
    padding: ${wellzThemeMui.spacing(2.5)};
  }
`;

export const Container = styled.div`
  width: 600px;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;

  ${wellzThemeMui.breakpoints.down('md')} {
    width: 100%;
  }

  .createInvite {
    flex-direction: column;
    display: flex;
    justify-content: space-between;
  }
`;

export const CloseIcon = styled(MuiClose)`
  fill: ${wellzThemeMui.palette.primary.main};
  width: ${wellzThemeMui.spacing(3)};
  height: ${wellzThemeMui.spacing(3)};
`;

export const ArrowLeftIcon = styled(ArrowBack)`
  fill: ${wellzThemeMui.palette.primary.main};
  width: ${wellzThemeMui.spacing(3)};
  height: ${wellzThemeMui.spacing(3)};
`;

export const Title = styled(Typography)`
  flex: 1;
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
`;

export const Footer = styled.div`
  padding-left: ${wellzThemeMui.spacing(7)};
  padding-top: ${wellzThemeMui.spacing(2)};
  padding-bottom: ${wellzThemeMui.spacing(5)};
  display: flex;
  gap: ${wellzThemeMui.spacing(3)};

  ${wellzThemeMui.breakpoints.down('md')} {
    width: 100%;
    flex-direction: column;
    padding: ${wellzThemeMui.spacing(2.5)};
  }
`;

export const Body = styled.div`
  padding: ${wellzThemeMui.spacing(2, 5)};
  flex: 1;

  .MuiAutocomplete-noOptions {
    background-color: white;
  }

  ${wellzThemeMui.breakpoints.down('md')} {
    padding: ${wellzThemeMui.spacing(2.5)};
  }

  .MuiFormControlLabel-label {
    color: ${wellzTheme.colors.text.primary};
    font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  }
`;

export const Checkbox = styled(MuiCheckbox)`
  &.Mui-checked {
    color: red !important;
  }

  &.MuiCheckbox-root:before,
  &.MuiCheckbox-root:after {
    color: red !important;
  }
`;

export const ContainerInputDate = styled.div`
  margin-top: ${wellzThemeMui.spacing(4)};
  margin-bottom: ${wellzThemeMui.spacing(3)};
  width: 100%;
`;

export const ContainerInputHour = styled.div`
  margin-bottom: ${wellzThemeMui.spacing(7)};
  width: 100%;
`;

export const ContainerData = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${wellzThemeMui.spacing(7)};
  flex: 1;
`;

export const ContainerInvite = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${wellzTheme.colors.moduleBorder};
  border-radius: ${wellzThemeMui.shape.borderRadius * 4}px;
  padding: ${wellzThemeMui.spacing(2)};
`;

export const ContainerWhite = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: ${wellzThemeMui.shape.borderRadius * 4}px;
  padding: ${wellzThemeMui.spacing(2)};
`;

export const ContainerRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  &.patient-avatar {
    margin-bottom: ${wellzThemeMui.spacing(3)};
  }
`;

export const PatientAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
  background-color: ${wellzTheme.colors.avatar};
  margin-right: ${wellzThemeMui.spacing(1)};
`;

export const CalendarIcon = styled(CalendarTodayOutlined)`
  width: 24px;
  height: 24px;
  margin-right: ${wellzThemeMui.spacing(1)};
  fill: #757575;
`;

export const HourIcon = styled(Schedule)`
  width: 24px;
  height: 24px;
  margin-right: ${wellzThemeMui.spacing(1)};
  fill: #757575;
`;

export const TextMedium = styled.b<{ color?: string }>`
  font-size: ${wellzThemeMui.typography.body2.fontSize}px;
  font-weight: ${wellzThemeMui.typography.fontWeightMedium};
  color: ${({ color }) => color || wellzThemeMui.palette.text.primary};
`;

export const CustomWarningAmberIcon = styled(WarningAmber)`
  fill: ${wellzTheme.colors.secondary};
`;
